import {
  Box,
  Button,
  Link,
  SimpleGrid,
  Text,
  VStack,
} from '@chakra-ui/react';
import { Link as RouterLink } from 'react-router-dom';
import { FaArrowRight, FaExternalLinkAlt } from 'react-icons/fa';
import { getBlogTrackAlternatives } from './blogOutingMaps.js';

export default function BlogTrackAlternatives({
  blogSlug,
  compact = false,
  onSelect,
  hideBookDirect = false,
}) {
  const config = getBlogTrackAlternatives(blogSlug);
  if (!config) return null;

  return (
    <VStack spacing={compact ? 3 : 4} align="stretch" w="full">
      <SimpleGrid columns={1} spacing={compact ? 2 : 3}>
        {config.alternatives.map((alt) => (
          <Button
            key={alt.path}
            as={RouterLink}
            to={alt.path}
            onClick={onSelect}
            variant="outline"
            size={compact ? 'sm' : 'md'}
            justifyContent="flex-start"
            h="auto"
            py={compact ? 3 : 4}
            px={4}
            whiteSpace="normal"
            textAlign="left"
            borderColor="brand.200"
            bg="white"
            _hover={{ bg: 'brand.50', borderColor: 'brand.400' }}
            rightIcon={<FaArrowRight />}
          >
            <Box flex="1">
              <Text fontWeight="bold" fontSize={compact ? 'sm' : 'md'}>
                {alt.name}
              </Text>
              <Text
                fontSize="xs"
                color="gray.600"
                fontWeight="normal"
                mt={1}
                lineHeight="short"
              >
                {alt.description}
              </Text>
            </Box>
          </Button>
        ))}
      </SimpleGrid>

      {!hideBookDirect && config.bookDirectUrl && (
        <Link
          href={config.bookDirectUrl}
          isExternal
          fontSize="sm"
          color="gray.600"
          textAlign="center"
          display="flex"
          alignItems="center"
          justifyContent="center"
          gap={2}
          _hover={{ color: 'brand.600' }}
        >
          {config.bookDirectLabel}
          <FaExternalLinkAlt size={12} />
        </Link>
      )}
    </VStack>
  );
}
